import { gql } from '@apollo/client';

export const ALL_MEMBERS_QUERY_NAME = 'AllMembers';
export const ALL_MEMBERS = gql`
    query ${ALL_MEMBERS_QUERY_NAME}(
        $page: Int,
        $perPage: Int,
        $query: String,
        $includeDeactivated: Boolean,
        $sortKey: String,
        $sortDirection: String,
        $valueMapping: Map_String_List_MappedValueScalar,
    ) {
        allMembers(
            page: $page,
            perPage: $perPage,
            query: $query,
            includeDeactivated: $includeDeactivated,
            sortKey: $sortKey,
            sortDirection: $sortDirection,
            valueMapping: $valueMapping,
        ) {
            availableMemberTypes,
            availablePaymentCurrencies {
                code
            },
            availableProductTypes,
            availableZones {
                code
                name
            },
            clearingEnabled,
            euAuctioneersEnabled,
            memberList {
                totalCount
                models {
                    id
                    name
                    memberId
                    suspended
                    suspendedBy
                    balancingGroup
                    memberType
                    active
                }
            }
        }
    }
`;

export const MEMBER_DETAIL_QUERY_NAME = 'MemberDetail';
export const MEMBER_DETAIL = gql`
    query ${MEMBER_DETAIL_QUERY_NAME}(
        $id: Int!,
    ) {
        memberDetail(
            id: $id,
        ) {
            id
            name
            memberId
            memberType
            suspended
            suspendedBy
            emails
            phone
            balancingGroup
            active
            foreignCurrencyAllowed
            euAuctioneer
            deactivationBlockers
            modificationBlockers
            users {
                racf
                userCode
                name
                email
                active
                suspended
            }
            paymentCurrency {
                code
            }
            zones {
                code
                name
            }
            cashLimits {
                currentAuctionDay
                nextAuctionDay
                initialCashLimit
                currentCashLimit
                nextAuctionDayInitialCashLimit
                clearingHouse {
                    code
                    timeZone {
                        ID
                    }
                }
                currency {
                    code
                }
            }
        }
    }
`;

export const CREATE_MEMBER = gql`
    mutation CreateMember(
        $name: String!, 
        $memberId: String!, 
        $memberType: MemberType!,
        $balancingGroup: String,
        $emails: String, 
        $phone: String, 
        $paymentCurrency: String,
        $foreignCurrencyAllowed: Boolean,
        $euAuctioneer: Boolean,
        $zones: [String],
        $correlationId: String!
    ) {
        createMember(
            name: $name, 
            memberId: $memberId, 
            memberType: $memberType,
            balancingGroup: $balancingGroup, 
            emails: $emails, 
            phone: $phone, 
            paymentCurrency: $paymentCurrency,
            foreignCurrencyAllowed: $foreignCurrencyAllowed,
            euAuctioneer: $euAuctioneer,
            zones: $zones,
            correlationId: $correlationId
        ) {
            name
            memberId
        }
    }
`;

export const UPDATE_MEMBER = gql`
    mutation UpdateMember(
        $id: Int!,
        $memberId: String!, 
        $name: String!, 
        $memberType: MemberType,
        $balancingGroup: String, 
        $emails: String, 
        $phone: String, 
        $paymentCurrency: String,
        $foreignCurrencyAllowed: Boolean,
        $euAuctioneer: Boolean,
        $zones: [String],
        $correlationId: String!,
        $extraConfirmation: Boolean = false,
    ) {
        updateMember(
            id: $id,
            memberId: $memberId, 
            name: $name, 
            memberType: $memberType,
            balancingGroup: $balancingGroup, 
            emails: $emails, 
            phone: $phone, 
            paymentCurrency: $paymentCurrency,
            foreignCurrencyAllowed: $foreignCurrencyAllowed,
            euAuctioneer: $euAuctioneer,
            zones: $zones,
            correlationId: $correlationId,
            extraConfirmation: $extraConfirmation,
        ) {
            name
            memberId
        }
    }
`;

export const TOGGLE_SUSPEND_MEMBER = gql`
    mutation ToggleMemberSuspension(
        $id: Int!, 
        $suspendedBy: String!,
        $correlationId: String!,
        $fourEyesUserId: String,
        $fourEyesPassword: String,
        $extraConfirmation: Boolean = false,
    ) {
        toggleMemberSuspension(
            id: $id,
            suspendedBy: $suspendedBy,
            correlationId: $correlationId,
            fourEyesUserId: $fourEyesUserId,
            fourEyesPassword: $fourEyesPassword,
            extraConfirmation: $extraConfirmation,
        ) {
            suspended
            suspendedBy
            name
            memberId
        }
    }
`;

export const TOGGLE_ACTIVATE_MEMBER = gql`
    mutation ToggleMemberActivation(
        $id: Int!,
        $correlationId: String!
    ) {
        toggleMemberActivation(
            id: $id,
            correlationId: $correlationId
        ) {
            active
            name
            memberId
        }
    }
`;

export const ON_MEMBER_CHANGED = gql`
    subscription onMemberChanged {
        memberChanged {
            correlationId
            action
            model {
                name
                memberId
            }
        }
    }
`;
